
    const _ = require("underscore");
    module.exports = function(context){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='<div class="tab-switcher"><div class="tab-switcher__overflow-container"><ul class="tab-switcher__tabs '+
((__t=( context.classes.join(' ') ))==null?'':_.escape(__t))+
'" data-tab-switcher>';
 _.each(context.tabs, function(tab) { 
__p+='<li class="tab-switcher__tab ';
 if (tab.isDefault) { 
__p+='tab-switcher__tab--active';
 } 
__p+=' '+
((__t=( tab.classes.join(' ') ))==null?'':_.escape(__t))+
'" data-tab-index="'+
((__t=( tab.index ))==null?'':_.escape(__t))+
'"><h5 class="mb0">'+
((__t=( tab.title ))==null?'':__t)+
'</h5></li>';
 }) 
__p+='</ul></div></div>';
return __p;
};
    